// extracted by mini-css-extract-plugin
export var fadeIn = "_dx-1";
export var modalContent = "_dx-3";
export var overlay = "_dx-0";
export var popoverContent = "_dx-2";
export var results = "_dx-5";
export var searchInputWrapper = "_dx-4";